<script lang="ts" setup>
import { MdiFaIcon } from '@ilteducation/components';
import { faListDropdown } from '@fortawesome/pro-regular-svg-icons';
import { useLocale } from '../../composables/useLocale';

defineOptions({ inheritAttrs: false });

const { t } = useLocale();

withDefaults(
  defineProps<{
    disabled?: boolean;
    label?: string;
    isHeader?: boolean;
    headerTooltip?: string;
  }>(),
  { disabled: false },
);
</script>

<template>
  <v-tooltip v-if="isHeader" :text="headerTooltip" :disabled="!headerTooltip" location="top">
    <template #activator="{ props: tooltipProps }">
      <span
        v-bind="disabled ? tooltipProps : { ...$attrs, ...tooltipProps }"
        :style="{ cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.38 : 1 }"
      >
        {{ label ?? t('lcp.add_group') }}
        <MdiFaIcon :icon="faListDropdown" />
      </span>
    </template>
  </v-tooltip>
  <v-btn
    v-else
    v-bind="$attrs"
    :disabled="disabled"
    variant="text"
    size="small"
    color="on-surface"
    class="d-flex justify-start text-body-1 font-weight-regular"
  >
    {{ label ?? t('lcp.add_group') }}
  </v-btn>
</template>
